// The query keys of the voice surfaces, and what a voice decision leaves stale.
import type { QueryClient } from '@tanstack/react-query'

export const voiceKeys = {
  identities: (caseId: string) => ['case', caseId, 'identity-voices'] as const,
  identity: (caseId: string, identityId: string) =>
    [...voiceKeys.identities(caseId), identityId] as const,
  unassigned: (caseId: string) => ['case', caseId, 'unassigned-voices'] as const,
  unassignedPage: (caseId: string, page: number) =>
    [...voiceKeys.unassigned(caseId), page] as const,
}

/** The audio tab's own read (`useIdentityAudio`), by prefix: every identity of the case. */
export const identityAudioKeys = (caseId: string) => ['case', caseId, 'identity-audio'] as const

/**
 * Everything a voice decision leaves stale besides the card that answered: the audio tab's
 * recordings, the unassigned tab and, unless `keepIdentity` names it, the identity's Voices card.
 */
export function invalidateVoices(
  queryClient: QueryClient,
  caseId: string,
  options: { keepIdentity?: string } = {}
): void {
  void queryClient.invalidateQueries({ queryKey: identityAudioKeys(caseId) })
  void queryClient.invalidateQueries({ queryKey: voiceKeys.unassigned(caseId) })
  void queryClient.invalidateQueries({
    queryKey: voiceKeys.identities(caseId),
    predicate: query =>
      options.keepIdentity === undefined || query.queryKey[3] !== options.keepIdentity,
  })
}
